import React, { useMemo } from 'react'
import { FormControl, FormHelperText, Typography, Box } from '@mui/material'

const sx = {
  masedInput: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: '300',
    width: '100%',
    color: '#132F6A',
    borderStyle: 'solid',
    boxShadow: 'none',
    outline: 'none !important',
    padding: '0 10px',
    border: '1px solid white',
    '&:hover': {
      border: '1px solid rgba(10, 120, 205, 1)',
    },
    '&:focus': {
      border: '1px solid rgba(10, 120, 205, 1)',
      borderWidth: '1px !important',
      boxShadow: 'none',
      outline: 'none !important',
    },
  },
  masedInputError: {
    backgroundColor: "rgba(254, 67, 52, 0.05)",
    padding: "0 35px",
    border: "1px solid red",
    '&:hover': {
      border: '1px solid red',
    },
    '&:focus': {
      border: "1px solid red",
    },
  },
  masedInputIcon: {
    padding: '0 35px',
  },
  helperTextRoot: {
    fontSize: 10,
    color: '#25245F',
    letterSpacing: '-0.33px',
    marginTop: 1,
  },
}

const TextArea = props => {
  const id = useMemo(() => Math.random().toString(32).substr(3), [])
  const style = { opacity: props.disabled ? 0.5 : 1, width: '100%', paddingTop: 27 }

  let masedInput = [sx.masedInput];

  if (props.error) {
    masedInput.push(sx.masedInputError)
  }

  if (props.icon) {
    masedInput.push(sx.masedInputIcon)
  }

  if (props)

    return (
      <FormControl fullWidth={props.fullWidth} style={style}>
        <Typography
          component={'label'}

          color={'primary'}
          htmlFor={id}
          sx={{
            marginBottom: '4px',
            fontSize: '14px',
            lineHeight: '21px',
            fontWeight: 500,
          }}
        >
          {props.label}
        </Typography>
        <Box component="textarea" sx={masedInput} {...props} />
        {props.helperText && (
          <FormHelperText classes={{ root: sx.helperTextRoot }} error={props.error}>
            {props.helperText}
          </FormHelperText>
        )}
      </FormControl>
    )
}

export default TextArea
